import { render, staticRenderFns } from "./PageFocused.vue?vue&type=template&id=4581d8ac"
import script from "./PageFocused.vue?vue&type=script&lang=js"
export * from "./PageFocused.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4581d8ac')) {
      api.createRecord('4581d8ac', component.options)
    } else {
      api.reload('4581d8ac', component.options)
    }
    module.hot.accept("./PageFocused.vue?vue&type=template&id=4581d8ac", function () {
      api.rerender('4581d8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/containers/PageFocused.vue"
export default component.exports